import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part9 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        const bullets = [
            "Treat the canonical model as a first-class product artifact. It defines the system’s behavior, constraints, and guarantees, and it must evolve with the same rigor as any customer-facing product.",
            "Require each PSP to explicitly declare its capabilities, limitations, and operating assumptions before integration. Capability discovery is a prerequisite for safe routing and correct orchestration.",
            "Compliance behavior must be derived from documented rules, contractual requirements, and observed production behavior. Sandbox success is insufficient evidence of real-world compliance or operational readiness.",
            "Routing decisions must be driven by capability fit and risk profile. Cost and price are secondary signals that are evaluated only after feasibility, compliance, and reliability constraints are satisfied.",
            "Persist every routing, validation, and decision outcome as structured data. These records form the basis for auditability, learning, optimization, and future automation.",
            "PSPs are structurally asymmetric across protocols, risk, coverage, and behavior. The orchestrator exists to absorb and normalize this asymmetry into a consistent internal model.",
            "Middleware components function as PSP-class dependencies. They introduce their own constraints, failure modes, and compliance considerations, and must be governed accordingly.",
            "Dynamic field engines are a strategic infrastructure. They enable jurisdiction-specific compliance, adaptive UX, and accurate validation at scale.",
            "Canonical metadata is the core asset of the platform. PSP APIs are replaceable execution layers that consume and produce this metadata.",
            "Without a formal capability matrix, each additional PSP increases operational complexity, integration risk, and failure modes in a linear and compounding manner.",
            "The relationship taxonomy directly feeds downstream systems, including user interface enumerations, normalization services, rule overlays that enforce relationship requirements, and risk-scoring inputs.",
            "Country-specific overlays inform the validation layer, drive dynamic form generation, constrain routing decisions, and support compliant audit exports.",
            "Error taxonomy underpins automated retry logic, cross-provider status reconciliation, customer-facing messaging, operational incident dashboards, and confidence scoring within the routing engine."
        ];

        return (
            <div className="docs-content">
                <div className="container">

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            Canonical Model Guidelines
                        </h1>

                        <ul className="doc-page">
                            {bullets.map((item, index) => (
                                <li key={index} className="mb-2">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </article>

                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-eight-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part VIII
                                            </Link>
                                        </li>
                                        {/* <li class="page-item">
                                            <Link class="page-link" to="/part-ten-doc">
                                                Part X &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li> */}
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>

                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}